import { GraphQLResult } from "@aws-amplify/api-graphql";
import { ListBoothBoatBrandsQuery } from "API";
import { API, graphqlOperation } from "aws-amplify";
import Select from "components/atoms/CmSelect";
import { listBoothBoatBrands } from "graphql/queries";
import * as React from "react";

type Props = {
  value: string;
  // value: any;
  onChange: any;
};

type Options = {
  name?: string;
  value?: string;
};

export default function SelectBrand(props: Props) {
  const { value, onChange } = props;
  const [options, setOptions] = React.useState<Options[]>([]);
  async function getBrand() {
    const res = (await API.graphql(
      graphqlOperation(listBoothBoatBrands),
      {}
    )) as GraphQLResult<ListBoothBoatBrandsQuery>;
    const brands = res?.data?.listBoothBoatBrands?.items;
    if (brands && brands?.length > 0) {
      const options = brands.map((item) => {
        return { name: item?.name, value: item?.name };
      });
      setOptions(options);
    }
  }

  React.useEffect(() => {
    getBrand();
  }, []);

  return <Select value={value} options={options} onChange={onChange} />;
}
